import React, { useState, Fragment } from "react";
import { useLocation } from "react-router-dom";
import { metaDefault } from "../../config/meta";
import { getString, purifiedParsedString } from "../../utilities";
import aboutStrings from "../../strings/about";
import Arrow from "../../../assets/svg/arrowRight.svg";
import ArrowTip from "../../../assets/svg/arrowTip.svg";

export default function Terms() {
  const location = useLocation();
  const [activeId, setActiveId] = useState(null);

  const renderTerms = () => {
    const { data } = aboutStrings.terms.TOC;
    if (data && data.length > 0) {
      return data.map((obj, i) => {
        const tocId = `tocId${i}`;
        const isActive = activeId === tocId;
        const toggleStyle = isActive ? "active" : "";
        const arrow = isActive ? (
          <Arrow aria-hidden="true" className="toggle-title-arrow" />
        ) : (
          <ArrowTip aria-hidden="true" className="toggle-title-arrow" />
        );

        return (
          <Fragment key={tocId}>
            <div
              id={tocId}
              role="button"
              aria-pressed={isActive}
              className={`wrapper toggle-title ${toggleStyle}`}
              tabIndex={i + 1}
              onClick={() => {
                if (activeId !== tocId) {
                  setActiveId(tocId);
                } else {
                  setActiveId(null);
                }
              }}
            >
              <div className="container toggle-title-container">
                <div className="toggle-title-text">{obj.title}</div>
                {arrow}
              </div>
            </div>
            <div aria-hidden="false" className={`wrapper padded even toggle-body ${toggleStyle}`}>
              <div className="container-medium">{purifiedParsedString(obj.body)}</div>
            </div>
          </Fragment>
        );
      }, []);
    }

    return null;
  };

  return (
    <>
      {metaDefault({ path: location.pathname, title: getString("terms.title.1") })}

      <div className="terms">
        <div className="wrapper padded">
          <div className="container">
            <h1>{getString("terms.title.2")}</h1>
          </div>
        </div>

        <div className="wrapper padded">
          <div className="container-medium">{getString("terms.body", { html: true, strings: aboutStrings })}</div>
        </div>

        <div className="wrapper odd">
          <div className="container toggle-section-header-text">
            {getString("terms.TOC.title", { strings: aboutStrings })}
          </div>
        </div>
        {renderTerms()}
      </div>

      <div className="wrapper header-shadow" />
    </>
  );
}
